import { useState, useEffect } from 'react';
import { getAuditLogs } from '../services/api';

const useAuditLogs = (page, limit, filters) => {
  const [auditData, setAuditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAuditLogs = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getAuditLogs(page, limit, filters);
        
        // Adaptar la estructura del backend a la esperada por el frontend
        const adaptedData = {
          data: response.recentActivity || [],
          total: response.totalLogs || 0,
          pagination: response.pagination || {},
          logsByEntityType: response.logsByEntityType || {},
          logsByAction: response.logsByAction || {},
          logsByUser: response.logsByUser || []
        };
        
        setAuditData(adaptedData);
      } catch (err) {
        setError(err);
        console.error('Error fetching audit logs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAuditLogs();
  }, [page, limit, filters]);

  const refetch = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAuditLogs(page, limit, filters);
      
      // Adaptar la estructura del backend a la esperada por el frontend
      const adaptedData = {
        data: response.recentActivity || [],
        total: response.totalLogs || 0,
        pagination: response.pagination || {},
        logsByEntityType: response.logsByEntityType || {},
        logsByAction: response.logsByAction || {},
        logsByUser: response.logsByUser || []
      };
      
      setAuditData(adaptedData);
    } catch (err) {
      setError(err);
      console.error('Error refetching audit logs:', err);
    } finally {
      setLoading(false);
    }
  };

  return {
    auditData,
    loading,
    error,
    refetch
  };
};

export default useAuditLogs;
